import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import LoansDrawer from '../../../app/loans/LoansDrawer';
import NpsScalePopup from '../../../app/nps/scale';
import { EngageCtaPopup } from '../engage/engage-cta-popup';
import { ClientReferralsCtaPopup } from '../../shop/client-referrals/client-referrals-cta-popup';
import UpdateStripeDataWarningModal from '../../../app/common/UpdateStripeDataWarningModal';
import SuggestAutoPayoutModal from '../../../app/main/suggestAutoPayoutModal';
import { RenewAppleLicencePopup } from '../renew-apple-licence';
import { SubscriptionMessagePopup } from '../subscription/subscription-message';
import { StripePopups } from '../onboarding';
import { TwoFaPopups } from '../auth/two-fa/two-fa-popups';
export var ShopViewPopups = function (_a) {
    var shopId = _a.shopId, getShopBankAccount = _a.getShopBankAccount;
    return (_jsxs(_Fragment, { children: [_jsx(LoansDrawer, {}), _jsx(NpsScalePopup, {}), _jsx(EngageCtaPopup, {}), _jsx(ClientReferralsCtaPopup, {}), _jsx(TwoFaPopups, {}), _jsx(UpdateStripeDataWarningModal, { ownerId: shopId, getBankAccount: getShopBankAccount }), _jsx(SuggestAutoPayoutModal, {}), _jsx(RenewAppleLicencePopup, {}), _jsx(SubscriptionMessagePopup, {}), _jsx(StripePopups, {})] }));
};
